import { appConfig as $config } from '../../app.config';
import { User } from '../User';
import { UI } from '../UI';
import { ItemCardNotice } from '../ItemCardNotice';
import { alertManagment, taskManagment } from '../ReactComponent';
import Sarus from './sarus';

export const WS = (function () {
  let $processTmr = [];
  let $sarus = null;

  const mapping = {
    message: (mess) => {
      let data = mess.AdditionalData;
      return {
        ...mess,
        ObjectId: mess.NotificationType == 7 ? 'ImportBom' : mess.ObjectId,
        isComplete: data && data.State ? true : false,
        isSuccess: data.State === 2,
        isError: data.State === 1
      };
    }
  };

  const init = () => {
    if (!User.accountID()) {
      return;
    }
    $sarus = new Sarus({
      url: $config.wssURL,
      eventListeners: {
        open: [wsOpened],
        message: [wsMessage],
        close: [wsClosed],
        error: [wsError]
      }
    });

    // Processing Storage
    //$storage.set('processing_messages', []);
    //processStoredMessages();

    // Process Saved Messages when page changed
    window.addEventListener('pagerender:complete', processStoredMessages);
  };

  const destroy = () => {
    if ($sarus) $sarus.disconnect();
  };

  const wsOpened = () => {
    console.log('Connection opened');
    send({ accountId: User.accountID(), userId: User.ID() });
  };

  const send = (mess) => {
    let message = JSON.stringify(mess);
    try {
      $sarus.send(message);
    } catch (e) {
      console.warn('WS message not send');
    }
  };

  const wsMessage = (event) => {
    let message = JSON.parse(event.data);
    if (!message) return;
    if (!Array.isArray(message)) message = [message];
    message.forEach((mess) => dispatchMessage(mapping.message(mess)));
  };

  const wsClosed = () => console.log('Connection closed');

  const wsError = (error) => console.log('Error', error);

  const dispatchMessage = (message) => {
    let process = message.ProcessType;
    if (process === 1) {
      /*if ($storage.get($config.storagekey.listenNotificationFrom) === 'client') {
        return;
      }*/
      notifyMessage(message);
    } else if (process === 0) {
      processingMessage(message);
    } else if (process === 2) {
      counterMessage(message);
    }
  };

  const notifyMessage = (mess) => {
    UI.notify({
      type: mess.isSuccess ? 'success' : 'danger',
      text: mess.AdditionalData.Text
    });
  };

  const processingMessage = (mess) => {
    let data = mess.AdditionalData;
    if (!data) return;

    // React Pages with process messages
    if (mess.NotificationType * 1 === 7) {
      // - Import BOM Processing Message
      mess.ObjectId = 'ImportBom';
    }

    ItemCardNotice.process(mess);
    storMessage(mess);
  };

  const counterMessage = (mess) => {
    let type = mess.NotificationType;

    // if(type==16){ // TaskCounter
    //   taskManagment.setCounter(mess.AdditionalData);
    // } else if(type == 17){ //AlertCounter
    //   alertManagment.setCounter(mess.AdditionalData);
    // }
  };

  const storMessage = (mess) => {
    let storedMess = $storage.get('processing_messages') || [];
    let id = mess.ObjectId;
    storedMess = storedMess.filter((obj) => obj.ObjectId !== id);
    if (!mess.isComplete) {
      storedMess.push(mess);
    }
    $storage.set('processing_messages', storedMess);
    processWaitingTimer(mess);
  };

  const processWaitingTimer = (mess) => {
    let id = mess.ObjectId;
    if ($processTmr[id]) {
      clearInterval($processTmr[id]);
    }
    if (!mess.isComplete) {
      $processTmr[id] = setInterval(() => {
        removeStoredMessage(id);
      }, $config.notification.processWaitingTimer);
    }
  };

  const removeStoredMessage = (id) => {
    let storedMess = $storage.get('processing_messages') || [];
    if (!storedMess.length) return;
    storedMess = storedMess.filter((obj) => obj.ObjectId !== id);
    $storage.set('processing_messages', storedMess);
  };

  const processStoredMessages = () => {
    let storedMess = $storage.get('processing_messages') || [];
    if (!storedMess.length) return;
    storedMess.forEach((mess) => processingMessage(mess));
  };

  return {
    init,
    destroy
  };
})();
